import { PageLayoutContentMainAreaAriaRole } from '@ms/yammer-web-core-ui/dist/components/PageLayout';
import { createContext } from 'react';

export interface AppContextOptions {
  readonly mainAreaAriaRole: PageLayoutContentMainAreaAriaRole;
  readonly enableCollapsiblePanelNav: boolean;
  readonly enableCommunityDiscoveryV2: boolean;
}

export const defaultOptions: AppContextOptions = {
  mainAreaAriaRole: PageLayoutContentMainAreaAriaRole.Main,
  enableCollapsiblePanelNav: false,
  enableCommunityDiscoveryV2: false,
};

export default createContext(defaultOptions);
